import design1 from "../assets/images/design1.png";
import target1 from "../assets/images/target1.jpg";
import renovation1 from "../assets/images/renovation1.jpg";
import sketch1 from "../assets/images/sketch1.jpg";

export const FEATURE_CARDS = [
  {
    icon: design1,
    titleKey: "Design construction",
    descriptionKey:
      "Playgrounds and floors are implemented according to standard specifications .",
  },
  {
    icon: target1,
    titleKey: "Precision",
    descriptionKey:
      "All products are approved by the International Federation of Tennis and Basketball Players",
  },
  {
    icon: renovation1,
    titleKey: "Renovation",
    descriptionKey:
      "All designs are planned from all planning works and reviewed by daily maintenance .",
  },
  {
    icon: sketch1,
    titleKey: "Design",
    descriptionKey:
      "All products are eco-friendly, animal-safe, and weather-resistant.",
  },
];
